(function () {
    'use strict';
    var controllerId = 'accredInfoEditAmmiss7';
    angular.module('app').controller(controllerId, ['common', '$scope', '$uibModalInstance', '_', 'datacontext', 'sectionMenu', 'accreditamento', 'isSuper', accredInfoEditAmmiss]);

    function accredInfoEditAmmiss(common, $scope, $uibModalInstance, _, datacontext, sectionMenu, accreditamento, isSuper) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, 'logError');
        var logSuccess = getLogFn(controllerId, 'logSuccess');

        $scope.accreditamento = jQuery.extend({}, accreditamento);
        $scope.isSuper = isSuper;

        $scope.ok = function (isValid) {
            if (isValid) {
                var result;
                result = updateItem($scope.accreditamento);
                $uibModalInstance.close(result);
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };


        function updateItem(item) {
            return datacontext.cndAccreditamento_update(item).then(function (data) {

                return data;
            });
        }

    }
})();